
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as HomeK_45Wab06JODWfc0RwaILz8QH_DTLS1_iohbaJdMmiK_45QMeta } from "/app/pages/Home.vue?macro=true";
import { default as LoginIV3DsbMZnc30VNCHRJ_OWKSOq6yftu3qo8_ulNBQPXkMeta } from "/app/pages/Login.vue?macro=true";
import { default as Profile8ViUSSBAt39CYyIw3pYNPwZLAnCoYqE9OQQ_459HBo0B4Meta } from "/app/pages/Profile.vue?macro=true";
import { default as TemplateJPI9tvMLqp4JDoE8It3YpBPzlQjDhrrzlAO6YXNnlb8Meta } from "/app/pages/Template.vue?macro=true";
import { default as NewsTaO6DKEZOnxTniJ69zIaGo_455Crv70lHGox8HJM8lXZkMeta } from "/app/pages/news/News.vue?macro=true";
import { default as WikisjXKjrtw__45pwSGDcgPWfSCYZj_45_45Xl04nFDnKa_45WxLK5AMeta } from "/app/pages/wiki/Wikis.vue?macro=true";
import { default as WheelfPCWn7iGnuIgOQ2nVeQi4xpNokpzkI2AjiQ5E2yQtGcMeta } from "/app/pages/admin/Wheel.vue?macro=true";
import { default as Preferences7jFjIwEihaVn0I7OZOipR_45r5fChDWkR7MTkNPfLd6hsMeta } from "/app/pages/Preferences.vue?macro=true";
import { default as Scout7DplzX75mX4iXqLt6_451pw_6I10RpyQMT3weL_45okBc_45wMeta } from "/app/pages/scout/Scout.vue?macro=true";
import { default as ServiceLogs_bTtJi5xjmqjm6BsE5hOcAupyslcaod1HaSeKko0_W4Meta } from "/app/pages/ServiceLogs.vue?macro=true";
import { default as ReleaseNotesDN2Dq6KwNveAVZ0TeYotIc5lGHgoXtrtMBlsbcOS2u0Meta } from "/app/pages/ReleaseNotes.vue?macro=true";
import { default as People_Oexlz2WZ0mXltk6xIi8Og9VKB36CSGWT7IgbDuNrxgMeta } from "/app/pages/people/People.vue?macro=true";
import { default as WikiPagedagui7HgyOW_uatMmPPztmdOeeNwLVnChudj_QrnY2MMeta } from "/app/pages/wiki/WikiPage.vue?macro=true";
import { default as NewsAdminCzbBFvasMKF_n7BO9ushYnDxqVn4RBcjPNNh4xkK8LgMeta } from "/app/pages/news/NewsAdmin.vue?macro=true";
import { default as ContactOz93w28iYgYfMNZfmX4f0kS1qn5zj8iURHNWFljw3RUMeta } from "/app/pages/people/Contact.vue?macro=true";
import { default as Cohortrw1fZeE7s9XdkFNXja838SEsaaDUVPLwL7S6saB_45O6kMeta } from "/app/pages/programs/Cohort.vue?macro=true";
import { default as Programykw0l6mlFe2sUzBVbMOoN9s6KNTP6FbNfFtiaS97bk8Meta } from "/app/pages/programs/Program.vue?macro=true";
import { default as Companysi4TowH67yqPuz9cbBDadTzUxoSGfMNeRD_j9aJRsqcMeta } from "/app/pages/startups/Company.vue?macro=true";
import { default as ProgramskBbFqO7bsCB2dju6q0u8ldFYUE8cPkjW7q_nGDmQ7VgMeta } from "/app/pages/programs/Programs.vue?macro=true";
import { default as Startups8q_v9MCzOHFxeQgyLGMW_RpoFgk1pITnAFXXZFHR7AoMeta } from "/app/pages/startups/Startups.vue?macro=true";
import { default as ContactEditnMELid_GmUXhB_45cXWsabd6s2LhQCukG0b1HfNXqAc_EMeta } from "/app/pages/people/ContactEdit.vue?macro=true";
import { default as ContactViewdwIXQ1IQJzS84FKKtZ2q4obifdo7rDvWiD39mt5ePCQMeta } from "/app/pages/people/ContactView.vue?macro=true";
import { default as TokenSelecteHx2AIrdFjPl6rK0TovRrXxibP1Q0iRBFYbYop30JUgMeta } from "/app/pages/tokens/TokenSelect.vue?macro=true";
import { default as InsightAddS9LUYEhuPyvYrifq6vtHRicrHML0fbGft11WqcdBr04Meta } from "/app/pages/insights/InsightAdd.vue?macro=true";
import { default as Investors5mnfOeMe6ExapJQLaJAGu3q7GGy_45mQUaw1GEZGszY5oMeta } from "/app/pages/investors/Investors.vue?macro=true";
import { default as TokenRequestA88paYLmwI_45odznWnsfnBeX4_45wPK3wP9yLuBVEA_RTAMeta } from "/app/pages/tokens/TokenRequest.vue?macro=true";
import { default as ChatbotViewROOtxXjeR4dPNqRUssMLo4LtiFDpEZ0t5KZ3a3ADqRYMeta } from "/app/pages/chatbots/ChatbotView.vue?macro=true";
import { default as InsightEdit1KUkxhUEYzTt0mStVFhMKHTD6IDLlq35q_45tDSeBaT1QMeta } from "/app/pages/insights/InsightEdit.vue?macro=true";
import { default as InsightViewVU31LM_N2ga3jT79Yy8ya8gvO4GEfvbkdxto5ybms_cMeta } from "/app/pages/insights/InsightView.vue?macro=true";
import { default as CompanyEditQ6UoCWdXiwh84_451VBNO9M2NsKDhrjvstJlKTGGDOX0AMeta } from "/app/pages/startups/CompanyEdit.vue?macro=true";
import { default as CompanyViewFbnlUeWkQPEfKri4PplO77nFrfNr2PC9kpIL7L5V8kQMeta } from "/app/pages/startups/CompanyView.vue?macro=true";
import { default as ChatbotIndexsIEfrkXTZsc4UmDD1WzrbplJODst45R08upNXcyOBaMMeta } from "/app/pages/chatbots/ChatbotIndex.vue?macro=true";
import { default as InsightIndexBddfDEgeA2ummqIN9Bo_lAKkIQ2GU8T13zf1BGg2FaEMeta } from "/app/pages/insights/InsightIndex.vue?macro=true";
import { default as Onboarding87VLR1jqvDBPXIytq5eB3v0apkq_tmFgSNcAJeV2YYMMeta } from "/app/pages/onboarding/Onboarding.vue?macro=true";
import { default as Collection3GXWjw7Yk_x4pre7CCAdyXPDHNmEe02h2WlumTh2vW4Meta } from "/app/pages/collections/Collection.vue?macro=true";
import { default as InvestorViewnyBdX7E8Nof8wKNEKA_45UjSzzNOSe994i_c33TemZHb8Meta } from "/app/pages/investors/InvestorView.vue?macro=true";
import { default as CollectionsnRWdr_45Yv_458WIlS_1N3yngPNPGQE_45a_ke_j6yZE_45Hu0UMeta } from "/app/pages/collections/Collections.vue?macro=true";
import { default as StartupsCsvUpdatevRzyS6nbuPmmjdH2F9GUl5cfH8C_vd_45yGHlhjsFQfxsMeta } from "/app/pages/startups/StartupsCsvUpdate.vue?macro=true";
import { default as OnboardingUpdatebztMw6i0_45sfWBlOsfCbkSQ9avSagq_454bCnV7__DgFxsMeta } from "/app/pages/onboarding/OnboardingUpdate.vue?macro=true";
import { default as StartupsBulkUpdateTgY_45y5cxiZjO3oiKu2MTHffArk7sySsab_45PTdU7nsYgMeta } from "/app/pages/startups/StartupsBulkUpdate.vue?macro=true";
export default [
  {
    name: "Home",
    path: "/Home",
    component: () => import("/app/pages/Home.vue")
  },
  {
    name: "Login",
    path: "/Login",
    component: () => import("/app/pages/Login.vue")
  },
  {
    name: "Profile",
    path: "/Profile",
    component: () => import("/app/pages/Profile.vue")
  },
  {
    name: "Template",
    path: "/Template",
    component: () => import("/app/pages/Template.vue")
  },
  {
    name: "news-News",
    path: "/news/News",
    component: () => import("/app/pages/news/News.vue")
  },
  {
    name: "wiki-Wikis",
    path: "/wiki/Wikis",
    component: () => import("/app/pages/wiki/Wikis.vue")
  },
  {
    name: "admin-Wheel",
    path: "/admin/Wheel",
    component: () => import("/app/pages/admin/Wheel.vue")
  },
  {
    name: "Preferences",
    path: "/Preferences",
    component: () => import("/app/pages/Preferences.vue")
  },
  {
    name: "scout-Scout",
    path: "/scout/Scout",
    component: () => import("/app/pages/scout/Scout.vue")
  },
  {
    name: "ServiceLogs",
    path: "/ServiceLogs",
    component: () => import("/app/pages/ServiceLogs.vue")
  },
  {
    name: "ReleaseNotes",
    path: "/ReleaseNotes",
    component: () => import("/app/pages/ReleaseNotes.vue")
  },
  {
    name: "people-People",
    path: "/people/People",
    component: () => import("/app/pages/people/People.vue")
  },
  {
    name: "wiki-WikiPage",
    path: "/wiki/WikiPage",
    component: () => import("/app/pages/wiki/WikiPage.vue")
  },
  {
    name: "news-NewsAdmin",
    path: "/news/NewsAdmin",
    component: () => import("/app/pages/news/NewsAdmin.vue")
  },
  {
    name: "people-Contact",
    path: "/people/Contact",
    component: () => import("/app/pages/people/Contact.vue")
  },
  {
    name: "programs-Cohort",
    path: "/programs/Cohort",
    component: () => import("/app/pages/programs/Cohort.vue")
  },
  {
    name: "programs-Program",
    path: "/programs/Program",
    component: () => import("/app/pages/programs/Program.vue")
  },
  {
    name: "startups-Company",
    path: "/startups/Company",
    component: () => import("/app/pages/startups/Company.vue")
  },
  {
    name: "programs-Programs",
    path: "/programs/Programs",
    component: () => import("/app/pages/programs/Programs.vue")
  },
  {
    name: "startups-Startups",
    path: "/startups/Startups",
    component: () => import("/app/pages/startups/Startups.vue")
  },
  {
    name: "people-ContactEdit",
    path: "/people/ContactEdit",
    component: () => import("/app/pages/people/ContactEdit.vue")
  },
  {
    name: "people-ContactView",
    path: "/people/ContactView",
    component: () => import("/app/pages/people/ContactView.vue")
  },
  {
    name: "tokens-TokenSelect",
    path: "/tokens/TokenSelect",
    component: () => import("/app/pages/tokens/TokenSelect.vue")
  },
  {
    name: "insights-InsightAdd",
    path: "/insights/InsightAdd",
    component: () => import("/app/pages/insights/InsightAdd.vue")
  },
  {
    name: "investors-Investors",
    path: "/investors/Investors",
    component: () => import("/app/pages/investors/Investors.vue")
  },
  {
    name: "tokens-TokenRequest",
    path: "/tokens/TokenRequest",
    component: () => import("/app/pages/tokens/TokenRequest.vue")
  },
  {
    name: "chatbots-ChatbotView",
    path: "/chatbots/ChatbotView",
    component: () => import("/app/pages/chatbots/ChatbotView.vue")
  },
  {
    name: "insights-InsightEdit",
    path: "/insights/InsightEdit",
    component: () => import("/app/pages/insights/InsightEdit.vue")
  },
  {
    name: "insights-InsightView",
    path: "/insights/InsightView",
    component: () => import("/app/pages/insights/InsightView.vue")
  },
  {
    name: "startups-CompanyEdit",
    path: "/startups/CompanyEdit",
    component: () => import("/app/pages/startups/CompanyEdit.vue")
  },
  {
    name: "startups-CompanyView",
    path: "/startups/CompanyView",
    component: () => import("/app/pages/startups/CompanyView.vue")
  },
  {
    name: "chatbots-ChatbotIndex",
    path: "/chatbots/ChatbotIndex",
    component: () => import("/app/pages/chatbots/ChatbotIndex.vue")
  },
  {
    name: "insights-InsightIndex",
    path: "/insights/InsightIndex",
    component: () => import("/app/pages/insights/InsightIndex.vue")
  },
  {
    name: "onboarding-Onboarding",
    path: "/onboarding/Onboarding",
    component: () => import("/app/pages/onboarding/Onboarding.vue")
  },
  {
    name: "collections-Collection",
    path: "/collections/Collection",
    component: () => import("/app/pages/collections/Collection.vue")
  },
  {
    name: "investors-InvestorView",
    path: "/investors/InvestorView",
    component: () => import("/app/pages/investors/InvestorView.vue")
  },
  {
    name: "collections-Collections",
    path: "/collections/Collections",
    component: () => import("/app/pages/collections/Collections.vue")
  },
  {
    name: "startups-StartupsCsvUpdate",
    path: "/startups/StartupsCsvUpdate",
    component: () => import("/app/pages/startups/StartupsCsvUpdate.vue")
  },
  {
    name: "onboarding-OnboardingUpdate",
    path: "/onboarding/OnboardingUpdate",
    component: () => import("/app/pages/onboarding/OnboardingUpdate.vue")
  },
  {
    name: "startups-StartupsBulkUpdate",
    path: "/startups/StartupsBulkUpdate",
    component: () => import("/app/pages/startups/StartupsBulkUpdate.vue")
  }
]